import { render, staticRenderFns } from "./BudgetInfo.vue?vue&type=template&id=57bf451a"
import script from "./BudgetInfo.vue?vue&type=script&lang=js"
export * from "./BudgetInfo.vue?vue&type=script&lang=js"
import style0 from "./BudgetInfo.vue?vue&type=style&index=0&id=57bf451a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports